import React, {useState } from "react";
import './App.css';
import Navbar from "./Component/Navbar";
import Footer from "./Component/Footer";
import Home from "./Pages/Home/Home";
import { Route, Routes, useLocation} from "react-router-dom";
import  * as Router from './Routes';
import AboutUs from "./Pages/AboutUs/AboutUs";
import Game from "./Pages/Game/Game";
import Progressive from './Pages/Services/progressiveapp/Progressive';
import MarketPlace from './Pages/Services/marketplace/MarketPlace';
import Blockchain from "./Pages/Blockchian/Blockchain";
import OurWork from "./Pages/OurWork/OurWork";
import NewOurWork from './Pages/OurWork/NewOurWork'
import OurPartners from './Pages/OurPartners/OurPartners'
import WebDevelopment from "./Pages/WebDevelopment/WebDevelopment";
import GameDev from "./Pages/GameDevelopment/GameDev";
import AppDevelopment from "./Pages/AppDevelopment/AppDevelopment";
// import Metaverse from "./Pages/Metaverse/Metaverse";
import ContactUs from "./Pages/ContactUs/ContactUs";
import TermsAndCondition from "./Pages/TermsAndContion/TermsAndCondition";
import PrivacyAndPolicy from "./Pages/PrivacyAndPolicy/PrivacyAndPolicy";
import Ethereum from "./Pages/Ethereum/Ethereum";
import CryptoCurrency from "./Pages/CryptoCurrency/CryptoCurrency";
import NftMarketPlace from "./Pages/NftMarketPlace/NftMarketPlace";
import Nft from "./Pages/Nfts/Nft";
import ExchangeCrypto from "./Pages/ExchangeCrypto/ExchangeCrypto";
import ScrollToTop from "./Component/ScrollToTop ";
import { WhatsappIcon } from "./Component/WhatsappIcon";
import Thankyou from "./Pages/AboutUs/Thankyou";
import Application from "./Pages/Careers/Application";
import Careers from "./Pages/Careers/Careers";
import JobList from "./Pages/Careers/JobList";
import { JobDescription } from "./Pages/Careers/JobDescription";
import { ToastContainer } from "react-toastify";
import { AllJobs } from "./Pages/Careers/AllJobs";
import { MainServicePage } from "./Component/NewServices/MainServicePage";
import { CaseStudy } from "./Component/CaseStudty/CaseStudy";
import Team from "./Component/Team/Team";
import MainBlog from "./Pages/BlogMainPage/BlogList/MainBlog";
import BlogDetail from "./Pages/BlogMainPage/BlogDetails/BlogDetail";
import RefundPolicy from "./Pages/RefundPolicy/RefundPolicy";
import WebsiteDev from "./Pages/Services/WebsiteDevelopment/WebsiteDevelopment";
import WebsiteDevelopment from "./Pages/Services/WebsiteDevelopment/WebsiteDevelopment";
import ARVR from "./Pages/Services/ARVRDevelopment/ARVR";
import { useEffect } from "react";
import ARVRDevelopmentServices from "./Pages/Services/ARVRDevelopment/ARVRDevelopmentServices ";
import MobileAppDevelopment from "./Pages/MobileAppDevelopment/MobileAppDevelopment";
import WebDevelopmentSerivce from "./Pages/Services/WebDevelopmentService/WebDevelopmentSerivce";
import UiService from "./Pages/Services/UiService/UiService";
// import { BrowserRouter as Route } from "react-router-dom";
import Crm from "./Pages/Services/CustomCrm/Crm";
import MachineLearning from "./Pages/Services/machinelearning/MachineLearning";
import ProductPage from "./Pages/Services/productpage/ProductPage";
import Metaverse from "./Pages/Services/metaverse/Metaverse";
import Decentralized from "./Pages/Services/decentralized/Decentralized";
import Generative from "./Pages/Services/Generative/Generative";
import Cloud from "./Pages/Services/cloud/Cloud";
import Outsource from "./Pages/Services/Outsource/Outsource";
import Devops from "./Pages/Services/Devops/Devops";
import Monitoring from "./Pages/Services/Monitoring/Monitoring";
import Healthcare from "./Pages/Services/healthcare/Healthcare";
import IntegrationPage from "./Pages/Services/IntegrationPage/IntegrationPage";
import Deploy from "./Pages/Services/deployment/Deploy";
import Containerization from "./Pages/Services/containerization/Containerization";
import Computing from "./Pages/Services/computing/Computing";
import Scalability from "./Pages/Services/scalability/Scalability";
import Orches from "./Pages/Services/orches/Orches";
import Security from "./Pages/Services/security/Security";
import Automation from "./Pages/Services/automation/Automation";
import Vision from "./Pages/Services/vision/Vision";
import CloudManage from "./Pages/Services/cloudManage/CloudManage";
import Business from "./Pages/Services/business/Business";
import Analytics from "./Pages/Services/analytics/Analytics";


function App() {
   const [showDropDown, setShowDropDown] = useState(false);
  const location = useLocation(); 
  const hideFooterOnPaths = [Router.ARVRDEV]; 
  const shouldShowHeaderFooter = !hideFooterOnPaths.includes(location.pathname);

useEffect(() => {
  if (location.pathname === "/ar-vr-development") {
    document.body.classList.add("route-ar-vr-development");
  } else {
    document.body.classList.remove("route-ar-vr-development");
  }
}, [location.pathname]);


  return (
      <div onClick={() => setShowDropDown(false)}>  
         {shouldShowHeaderFooter && <Navbar showDropDown={showDropDown} setShowDropDown={setShowDropDown}/>} 
          <ScrollToTop />
          <Routes>
            <>
           <Route path={Router.HOME} element={<Home/>}/>
           <Route path={Router.ABOUTUS} element={<AboutUs/>}/>
           <Route path={Router.THANKYOU} element={<Thankyou/>}/>
           <Route path={Router.CONTACTUS} element={<ContactUs/>}/>
            <Route path={Router.GAMEDEV} element={<GameDev/>}/>
           <Route path={Router.GAME} element={<Game/>}/>
           <Route path={Router.PROGRESSIVE} element={<Progressive/>}/>
           <Route path={Router.MACHINELEARNING} element={<MachineLearning/>}/>
           <Route path={Router.GENERATIVEAI} element={<Generative/>}/>
           <Route path={Router.CLOUDMANAGE} element={<CloudManage/>}/>
           <Route path={Router.CLOUD} element={<Cloud/>}/>
           <Route path={Router.AUTOMATION} element={<Outsource/>}/>
           <Route path={Router.OUTSOURCE} element={<Automation/>}/>
           <Route path={Router.BUSINESS} element={<Business/>}/>
           <Route path={Router.ANALYTICS} element={<Analytics/>}/>
           <Route path={Router.VISION} element={<Vision/>}/>
           <Route path={Router.DEVOPS} element={<Devops/>}/>
           <Route path={Router.INTEGRATION} element={<IntegrationPage/>}/>
           <Route path={Router.DEPLOYMENT} element={<Deploy/>}/>
           <Route path={Router.CONTAINERIZATION} element={<Containerization/>}/>
           <Route path={Router.COMPUTING} element={<Computing/>}/>
           <Route path={Router.SCALABILITY} element={<Scalability/>}/>
           <Route path={Router.ORCHES} element={<Orches/>}/>
            <Route path={Router.SECURITY} element={<Security/>}/>
           <Route path={Router.HEALTHCARE} element={<Healthcare/>}/>
            <Route path={Router.MONITOR} element={<Monitoring/>}/>
            <Route path={Router.PRODUCT} element={<ProductPage/>}/>
            <Route path={Router.NFTMARKETPLACE} element={<MarketPlace/>}/>
            <Route path={Router.METAVERSE} element={<Metaverse/>}/>
           <Route path={Router.DAPP} element={<Decentralized/>}/>
           <Route path={Router.BLOCKCHAIN} element={<Blockchain/>}/>
           <Route path={Router.WEBDEVELOPEMENT} element={<WebDevelopment/>}/>
           <Route path={Router.APPDEVELOPMENT} element={<AppDevelopment/>} />
           <Route path={Router.OURWORK} element={<NewOurWork/>}/>
           <Route path={Router.OURPARTNERS} element={<OurPartners/>}/>
           {/* <Route path={Router.METAVERSEDEVELOPMENT} element={<Metaverse/>}/> */}
           <Route path={Router.TERMSANDCONDITIONS} element={<TermsAndCondition/>}/>
           <Route path={Router.PRIVACYANDPOLICY} element={<PrivacyAndPolicy/>}/>
           <Route path={Router.REFUNDPOLICY} element={<RefundPolicy/>}/>
           <Route path={Router.ETHEREUM} element={<Ethereum/>}/>
           <Route path={Router.CRYPTOCURRENCY} element={<CryptoCurrency/>}/>
           {/* <Route path={Router.NFTMARKETPLACE} element={<NftMarketPlace/>} /> */}
           <Route path={Router.NFT} element={<Nft/>}/>
           <Route path={Router.EXCHANGECRYPTO} element={<ExchangeCrypto/>}/>
           <Route path={Router.APPLICATION} element={<Application/>}/>
           <Route path={Router.CAREERS} element={<Careers/>}/>
           <Route path={Router.DEFAULT} element={<Home/>}/>
           <Route path={Router.SWIPER} element={<JobList/>}/>
           <Route path={Router.JOBDESCRIPTION} element={<JobDescription/>}/>
           <Route path={Router.ALLJOBS} element={<AllJobs/>}/>
           <Route path={Router.BLOGMAINPAGE} element={<MainBlog/>}/>
           <Route path={Router.BLOGDETAIL} element={<BlogDetail/>}/>
           {/* <Route path={Router.WEBDEV} element={<WebsiteDevelopment/>}/> */}
           <Route path={Router.MOBILEAPPDEVELOPMENT} element={<MobileAppDevelopment/>}/>
           <Route path={Router.WEBDEV} element={<WebDevelopmentSerivce/>}/>
            <Route path={Router.ARVRDEV} element={<ARVR/>}/>
            <Route path={Router.ARVRDevelopmentServices} element={<ARVRDevelopmentServices/>}/>
           {/* <Route path={Router.SERVICES} element={<MainServicePage/>}/> */}
           <Route path={Router.CASE_STUDY} element={<CaseStudy/>}/>
           {/* <Route path={Router.TEAM} element={<Team/>}/> */}
           <Route path={Router.UIUX} element={<UiService/>}/>
           <Route path={Router.CRMDEVELOPMENT} element={<Crm/>}/>
           </>
          </Routes>
          {shouldShowHeaderFooter && <Footer/>}
          <WhatsappIcon />
          <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover /> 
      </div>
  );
}

export default App;
